import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { NavLink as RouterNavLink } from 'react-router-dom';
import { listRequest as listRequestAction} from '../../store/dashboard/actions'
import { getDashboard } from '../../store/dashboard/selectors';
import queryString from 'query-string'
import { Container, Button, Spinner, Col, Row, Form, FormGroup, Label, Input, Alert,
    Nav, NavItem, NavLink, TabContent, TabPane, CustomInput,
    Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback, FormText, ListGroup, ListGroupItem, ListGroupItemHeading, Progress, Badge } from 'reactstrap';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

interface IState {
}

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    route: any
    data: any
    ui : any
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    listRequest : typeof listRequestAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class DashboardMainPage extends React.Component<AllProps, IState> {
    constructor(props: AllProps) {
        super(props);
        this.ListRequest = this.ListRequest.bind(this);
    }

    public componentDidMount() {
        const parsed = queryString.parse(this.props.route.location.search);
        const { searchParams: stateSP } = this.props.ui;
       
        this.ListRequest();
    }

    componentDidUpdate(prevProps: AllProps) {

    }
    
    public componentWillUnmount() {
    } 
   
    public ListRequest(){
        var searchParams:any = {};
        this.props.listRequest(searchParams);
    }

    public render() {
        const { ui } = this.props.ui;

        let userData = this.props.data.filter(function (e: any) { return e.id === "UserStatistics" });

        return (
            <Container className="bg-light">
                <br/>
                <h2>Dashboard  <Spinner color="warning" hidden={!this.props.ui.loading} /></h2>
                <Form id='DetailsFrom' className="mt-6 mb-6">
                    {
                        userData.length > 0 &&
                        <ListGroup>
                            <ListGroupItem>
                                <ListGroupItemHeading>
                                    User&nbsp;
                                    <Button color="secondary" name="image" size="sm" onClick={this.ListRequest}><i className="fas fa-sync mr-1"></i></Button>
                                </ListGroupItemHeading>
                                <ListGroupItem>
                                    <FormGroup row={true}>
                                        <Label for="orgName" sm={3}>Total User</Label >
                                        <Col lg={3} sm={3}>
                                            {/* <Input type="text" name="orgName" readOnly value={userData[0].totUser} /> */}
                                            <a href="/#/users?term=&userstatus=&sorting=" className="nav-link">
                                                {userData[0].totUser}&nbsp;&nbsp;<Badge color="primary">View</Badge>
                                            </a>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row={true}>
                                        <Label for="orgName" sm={3}>Total New User this month</Label >
                                        <Col lg={3} sm={3}>
                                            {/* <Input type="text" name="orgName" readOnly value={userData[0].totNewUserMtd} /> */}
                                            <a href="/#/users?term=&userstatus=&sorting=&mtdnewuser=Y" className="nav-link">
                                                {userData[0].totNewUserMtd}&nbsp;&nbsp;<Badge color="primary">View</Badge>
                                            </a>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row={true}>
                                        <Label for="orgName" sm={3}>Total User Pending Approval</Label >
                                        <Col lg={3} sm={3}>
                                            {/* <Label for="orgName" sm={3}>{userData[0].totUserPendingApproval}</Label > */}
                                            {/* <Input type="text" name="orgName" readOnly value={userData[0].totUserPendingApproval} /> */}
                                            <a href="/#/users?term=&userstatus=Pending%20Approval&sorting=" className="nav-link">
                                                {userData[0].totUserPendingApproval}&nbsp;&nbsp;<Badge color="primary">View</Badge>
                                            </a>
                                        </Col>
                                    </FormGroup>
                                </ListGroupItem>
                            </ListGroupItem>
                        </ListGroup>
                    }
                    
                </Form>
            </Container>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    ui: state.dashboard.ui,
    data: getDashboard(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    listRequest : listRequestAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DashboardMainPage)
